// Local storage service for secure token management
class StorageService {
  private readonly TOKEN_KEY =
    process.env.REACT_APP_TOKEN_STORAGE_KEY || 'allendco_auth_token';
  private readonly REFRESH_TOKEN_KEY =
    process.env.REACT_APP_REFRESH_TOKEN_KEY || 'allendco_refresh_token';
  private readonly USER_KEY = 'allendco_user_info';

  // Access Token methods
  getAccessToken(): string | null {
    return localStorage.getItem(this.TOKEN_KEY);
  }

  setAccessToken(token: string): void {
    localStorage.setItem(this.TOKEN_KEY, token);
  }

  removeAccessToken(): void {
    localStorage.removeItem(this.TOKEN_KEY);
  }

  // Refresh Token methods
  getRefreshToken(): string | null {
    return localStorage.getItem(this.REFRESH_TOKEN_KEY);
  }

  setRefreshToken(token: string): void {
    localStorage.setItem(this.REFRESH_TOKEN_KEY, token);
  }

  removeRefreshToken(): void {
    localStorage.removeItem(this.REFRESH_TOKEN_KEY);
  }

  // User Info methods
  getUserInfo(): Record<string, unknown> | null {
    const userStr = localStorage.getItem(this.USER_KEY);
    if (!userStr) return null;

    try {
      return JSON.parse(userStr);
    } catch {
      return null;
    }
  }

  setUserInfo(user: Record<string, unknown>): void {
    localStorage.setItem(this.USER_KEY, JSON.stringify(user));
  }

  removeUserInfo(): void {
    localStorage.removeItem(this.USER_KEY);
  }

  // Clear all stored data
  clearAll(): void {
    this.removeAccessToken();
    this.removeRefreshToken();
    this.removeUserInfo();
  }

  // Check if user is authenticated
  isAuthenticated(): boolean {
    return !!this.getAccessToken();
  }
}

export const storageService = new StorageService();
